import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listEvents, deleteEvent } from "../../../api/cms";

export default function AdminEvents() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = () => {
    setLoading(true);
    listEvents()
      .then((items) =>
        setEvents(
          [...items].sort((a, b) => {
            const da = new Date(b.dateTime || b.dateTimeFrom);
            const db = new Date(a.dateTime || a.dateTimeFrom);
            return da - db;
          })
        )
      )
      .catch(() => setError("Failed to load events"))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this event?")) return;
    await deleteEvent(id);
    load();
  };

  if (loading) return <p>Loading…</p>;
  if (error) return <p className="text-red-500">{error}</p>;

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Events</h1>
        <Link to="/admin/events/new" className="bg-bahyellow rounded px-4 py-2 text-sm font-semibold hover:opacity-90">
          + Add event
        </Link>
      </div>
      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-left">
            <tr>
              <th className="px-4 py-3 font-semibold">Title</th>
              <th className="px-4 py-3 font-semibold">Date</th>
              <th className="px-4 py-3 font-semibold">Location</th>
              <th className="px-4 py-3" />
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {events.map((ev) => (
              <tr key={ev.id}>
                <td className="px-4 py-3 font-medium max-w-xs truncate">{ev.title}</td>
                <td className="px-4 py-3 text-gray-500 whitespace-nowrap">
                  {ev.dateTime
                    ? new Date(ev.dateTime).toLocaleDateString("en-GB")
                    : ev.dateTimeFrom
                    ? `${new Date(ev.dateTimeFrom).toLocaleDateString("en-GB")} – ${new Date(ev.dateTimeTo).toLocaleDateString("en-GB")}`
                    : "—"}
                </td>
                <td className="px-4 py-3 text-gray-500 max-w-xs truncate">{ev.location}</td>
                <td className="px-4 py-3 text-right space-x-3 whitespace-nowrap">
                  <Link to={`/admin/events/${ev.id}/edit`} className="text-blue-600 hover:underline">Edit</Link>
                  <button onClick={() => handleDelete(ev.id)} className="text-red-500 hover:underline">Delete</button>
                </td>
              </tr>
            ))}
            {events.length === 0 && (
              <tr><td colSpan={4} className="px-4 py-8 text-center text-gray-400">No events yet</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
